module.exports = __webpack_public_path__ + "img/erp-logos_0035_datapel.5a8ea1a2.jpg";